import { Text } from "react-native-paper";
import { useAppTheme } from "../../useAppTheme";
import RecorderIconButton from "./RecorderIconButton";
import StatusHeader from "./StatusHeader";
import type { AudioRecorderState, AudioRecorderType } from "./index";

type LabelTextProps = {
	label: string;
};

const LabelText = ({ label }: LabelTextProps) => {
	const theme = useAppTheme();
	return (
		<Text
			variant="titleSmall"
			style={{ color: theme.colors.secondary, flex: 1, fontWeight: "500" }}
			numberOfLines={2}
		>
			{label}
		</Text>
	);
};

type Props = {
	state: AudioRecorderState;
	type: AudioRecorderType;
	isPlaying: boolean;
	isLoading: boolean;
	disabled: boolean;
	defaultLabel: string;
	recordingLabel: string;
	recordedLabel: string;
	expiredLabel: string;
	autoRecordPromptLabel: string;
	handleRecord: () => void;
};

const RecorderLeading = ({
	state,
	type,
	isPlaying,
	isLoading,
	disabled,
	defaultLabel,
	recordingLabel,
	recordedLabel,
	expiredLabel,
	autoRecordPromptLabel,
	handleRecord,
}: Props) => {
	const isAutoRecord = type === "autoRecord";

	// `disabled` gates capture only, so the play button always renders enabled.
	const playButton = (
		<RecorderIconButton
			variant="filled"
			icon={isPlaying ? "pause" : "play"}
			onPress={handleRecord}
			loading={isLoading}
			disabled={false}
			a11yLabel={isPlaying ? "Pause" : "Play"}
		/>
	);

	if (isAutoRecord) {
		if (state === "recording") {
			return (
				<StatusHeader variant="recording" label={recordingLabel} dotSize={12} />
			);
		}
		if (state === "recorded") {
			// Live timed flow keeps the status header; once answered, show play
			// so the response can be reviewed.
			return disabled ? (
				playButton
			) : (
				<StatusHeader variant="completed" label={recordedLabel} />
			);
		}
		return (
			<LabelText
				label={state === "expired" ? expiredLabel : autoRecordPromptLabel}
			/>
		);
	}

	if (state === "recording") {
		return (
			<StatusHeader variant="recording" label={recordingLabel} dotSize={8} />
		);
	}
	if (state === "recorded") {
		return playButton;
	}
	return (
		<LabelText label={state === "expired" ? expiredLabel : defaultLabel} />
	);
};

export default RecorderLeading;
